import "./App.scss";
import { Outlet } from "react-router-dom";
import { Header } from "../Shared/components/Header";
import { Footer } from "../Shared/components/Footer";

export const Home = () => {
  return (
    <>
      <div className="mx-auto">
        <Header />
      </div>
      <div className="mx-auto">
        <div className="mx-auto pt-20">
          <div className="">
            <Outlet />
          </div>
          <div className="bg-flag">
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};
